<script setup lang="ts">
import { computed } from 'vue';
import { describeOperatingSystem } from '../lib/operating-system.js';
import OsIcon from './OsIcon.vue';

/**
 * The operating system as a person reads it: logo, product name and a short
 * version ("Windows 11 · build 26200"). Unknown systems show the fallback copy.
 */
const props = defineProps<{
  platform: string;
  version?: string | undefined;
  fallback?: string | undefined;
  /** Hide the version and show the name only, for tight rows. */
  compact?: boolean | undefined;
}>();
const system = computed(() => describeOperatingSystem(props.platform, props.version));
const fallback = computed(() => props.fallback || 'System not reported');
const title = computed(() =>
  system.value
    ? system.value.reported || system.value.name
    : [fallback.value, props.version].filter(Boolean).join(' · '),
);
</script>

<template>
  <span class="os-identity" :title="title">
    <template v-if="system">
      <OsIcon :platform="props.platform" :version="props.version" />
      <span class="os-name">{{ system.name }}</span>
      <span v-if="system.version && !props.compact" class="os-version">{{ system.version }}</span>
    </template>
    <span v-else class="os-fallback">{{ fallback }}</span>
  </span>
</template>
